import store from '@/state/store';
import { editParticipant } from '@/api/project';
import { handleError } from '@/actions/common';
import { AccessLevel } from '@bimdata/definitions/const';
import projectSlice from '@/state/project.slice';
import { Invitation } from '@/state/types/invitation';
import { runBulk } from '../utils';

export default async (code: string, invitations: Invitation[], access: AccessLevel) => {
  try {
    const ids = await runBulk(
      invitations,
      (invitation) => editParticipant(
        code,
        typeof invitation.participant === 'string' ? invitation.participant : invitation.participant.id,
        access
      ).then(() => invitation.id),
      (e) => handleError(e)
    );

    store.dispatch(
      projectSlice.actions.setInvitationsAccessLevel({
        code,
        ids,
        access,
      })
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};